export const SET_USER_ROLES_WITH_USER_PROFILES_LOADED = "SET_USER_ROLES_WITH_USER_PROFILES_LOADED";

export const setUserRolesWithUserProfilesLoaded = (userRolesWithUserProfilesLoaded: boolean) => {
  return {
    userRolesWithUserProfilesLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_ROLES_WITH_USER_PROFILES_LOADED
  };
};
